// One interruptible crossfade per panel group. Navigation and data loading never wait for it.
const running = new Map();
const reducedMotion = globalThis.matchMedia?.('(prefers-reduced-motion: reduce)');
reducedMotion?.addEventListener?.('change', () => {
    if (reducedMotion.matches) for (const finish of [...running.values()]) finish();
});

export function changePanels(from, to, update, direction = 1) {
    const parent = to?.parentElement;
    for (const [host, finish] of [...running]) {
        if (host === parent || from?.contains(host) || to?.contains(host)) finish();
    }
    const canAnimate = from && to && from !== to && from.parentElement === parent
        && from.getClientRects().length && !reducedMotion?.matches && to.animate
        && !parent.closest('[data-panel-entering]');
    if (!canAnimate) { update(); return; }

    const display = getComputedStyle(from).display;
    const rect = from.getBoundingClientRect();
    const hostRect = parent.getBoundingClientRect();
    const properties = ['position', 'top', 'left', 'width', 'margin', '--panel-display'];
    const saved = properties.map(key => [key, from.style.getPropertyValue(key), from.style.getPropertyPriority(key)]);
    const wasInert = from.inert;
    const positioned = getComputedStyle(parent).position === 'static';
    if (positioned) parent.classList.add('panel-motion-host');
    from.style.setProperty('--panel-display', display);
    from.style.position = 'absolute';
    from.style.top = `${rect.top - hostRect.top + parent.scrollTop - parent.clientTop}px`;
    from.style.left = `${rect.left - hostRect.left + parent.scrollLeft - parent.clientLeft}px`;
    from.style.width = `${rect.width}px`;
    from.style.margin = '0';
    from.inert = true;
    from.setAttribute('data-panel-leaving', '');
    to.setAttribute('data-panel-entering', '');

    let animations = [], finished = false;
    const finish = () => {
        if (finished) return;
        finished = true;
        animations.forEach(animation => animation.cancel());
        from.removeAttribute('data-panel-leaving');
        to.removeAttribute('data-panel-entering');
        for (const [key, value, priority] of saved) {
            if (value) from.style.setProperty(key, value, priority);
            else from.style.removeProperty(key);
        }
        from.inert = wasInert;
        if (positioned) parent.classList.remove('panel-motion-host');
        if (running.get(parent) === finish) running.delete(parent);
    };
    running.set(parent, finish);
    try {
        update();
        animations = [
            from.animate([{ opacity: 1, transform: 'translateX(0)' }, { opacity: 0, transform: `translateX(${-8 * direction}px)` }],
                { duration: 160, easing: 'ease-out', fill: 'both' }),
            to.animate([{ opacity: 0, transform: `translateX(${16 * direction}px)` }, { opacity: 1, transform: 'translateX(0)' }],
                { duration: 240, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' }),
        ];
        Promise.all(animations.map(animation => animation.finished)).then(finish, finish);
    } catch (error) {
        finish();
        throw error;
    }
}
